import React from 'react';
import NumberFormat from 'react-number-format';
import DifferenceMarker from '../../components/DifferenceMarker/DifferenceMarker';
import classes from './PlanWealth.css';

const planWealth = (props) => {
    let marker90 = null;
    let marker50 = null;
    let marker10 = null;

    if (props.showDifference) {
        marker90 = (
            <DifferenceMarker
                value={props.wealth.percentile90Change}
            />
        );
        marker50 = (
            <DifferenceMarker
                value={props.wealth.percentile50Change}
            />
        );
        marker10 = (
            <DifferenceMarker
                value={props.wealth.percentile10Change}
            />
        );
    }

    return (
        <div className="PlanWealth">
            <div className="wealthSpacer"></div>
            <div className="percentileRow">
                <NumberFormat
                    value={props.wealth.percentile90}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale="0"
                />
                {marker90}
            </div>
            <div className="percentileRow">
                <NumberFormat
                    value={props.wealth.percentile50}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale="0"
                />
                {marker50}
            </div>
            <div className="percentileRow">
                <NumberFormat
                    value={props.wealth.percentile10}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale="0"
                />
                {marker10}
            </div>
        </div>
    );
};

export default planWealth;


// WEBPACK FOOTER //
// ./src/components/PlanWealth/PlanWealth.js